export default "__VITE_PUBLIC_ASSET__281b7c5d__"